export const TRANSFER_MODES = {
  ENTITIES: 'entities' as const,
  FULL: 'full' as const,
} as const

export type TransferMode =
  | typeof TRANSFER_MODES.ENTITIES
  | typeof TRANSFER_MODES.FULL

export const DEFAULT_MESSAGE_PERIOD = 30

export const AGENT_TYPES = {
  CLIENT: 0,
  PARTNER: 1,
  GROUP: 2,
  ADMIN_GROUP: 3,
  TEST_CLIENT: 4,
  CONTRACT: 5,
} as const

export const AGENT_TYPE_TEXTS = {
  [AGENT_TYPES.CLIENT]: 'Клиент',
  [AGENT_TYPES.PARTNER]: 'Партнер',
  [AGENT_TYPES.GROUP]: 'Группа',
  [AGENT_TYPES.ADMIN_GROUP]: 'Административная группа',
  [AGENT_TYPES.TEST_CLIENT]: 'Тестовый клиент',
  [AGENT_TYPES.CONTRACT]: 'Договор',
  default: 'Неизвестно',
}

export const AGENT_STATUSES = {
  INACTIVE: 0,
  ACTIVE: 1,
} as const

export const AGENT_STATUS_TEXTS = {
  [AGENT_STATUSES.INACTIVE]: 'Неактивна',
  [AGENT_STATUSES.ACTIVE]: 'Активна',
  default: 'Неизвестно',
}
